import React, {PureComponent} from "react"

import {Reward} from "@irati/types"
import {getDealTileImage, getThumbnailImage} from "@irati/utils/images"
import getId from "@irati/utils/id"

import {BannerImage, BannerOverlay, BannerWrapper, BannerAvatar} from "./styled/Banner"

interface Props {
  id: string,
  reward: Reward
}

export default class BannerComponent extends PureComponent<Props> {
  render() {
    const {id, reward} = this.props
    const thumbnail = getThumbnailImage(reward.thumbnailImage)

    return (
      <BannerWrapper id={id}>
        <BannerImage id={getId("image", this.props)} src={getDealTileImage(reward.cardImage)} alt="" />
        <BannerOverlay />
        <BannerAvatar id={getId("thumbnail", this.props)} src={thumbnail} alt="" small withShadow />
      </BannerWrapper>
    )
  }
}
